"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapGameListGame = exports.mapDate = exports.sanitizeGameId = void 0;
var types_1 = require("@pose-party/types");
/**
 * Utility to sanitise game id's
 * All lowercase, trims, and replaces spaces with dashes
 */
var sanitizeGameId = function (input) {
    return input.trim().replace(new RegExp(" ", "g"), "-");
};
exports.sanitizeGameId = sanitizeGameId;
/**
 * Maps an unknwon value to a date, or null
 */
var mapDate = function (input) {
    if (typeof input !== "string" && typeof input !== "number") {
        return null;
    }
    return new Date(input);
};
exports.mapDate = mapDate;
/**
 * Maps a firebase document to a game list game
 */
var mapGameListGame = function (data) {
    var _a;
    var values = data.data();
    return {
        id: data.id,
        status: (values === null || values === void 0 ? void 0 : values.status) || types_1.GameListGameStatus.Setup,
        name: (values === null || values === void 0 ? void 0 : values.name) || null,
        host: (values === null || values === void 0 ? void 0 : values.host) || null,
        hostEmail: (values === null || values === void 0 ? void 0 : values.hostEmail) || null,
        createdAt: exports.mapDate(values === null || values === void 0 ? void 0 : values.createdAt),
        startedAt: exports.mapDate(values === null || values === void 0 ? void 0 : values.startedAt),
        finishedAt: exports.mapDate(values === null || values === void 0 ? void 0 : values.finishedAt),
        tournamentId: (values === null || values === void 0 ? void 0 : values.tournamentId) || null,
        inPerson: (values === null || values === void 0 ? void 0 : values.inPerson) || false,
        demo: (values === null || values === void 0 ? void 0 : values.demo) || false,
        demoHost: (values === null || values === void 0 ? void 0 : values.demoHost) || null,
        deleted: (values === null || values === void 0 ? void 0 : values.deleted) || false,
        locked: (values === null || values === void 0 ? void 0 : values.locked) || false,
        large: (values === null || values === void 0 ? void 0 : values.large) || false,
        largeGroupSize: (values === null || values === void 0 ? void 0 : values.largeGroupSize) || null,
        activePlayers: (_a = values === null || values === void 0 ? void 0 : values.activePlayers) !== null && _a !== void 0 ? _a : null,
    };
};
exports.mapGameListGame = mapGameListGame;
//# sourceMappingURL=game.js.map